import { connect } from "react-redux";
import OverviewLayout from "./";

import { setNavSection } from "../../state/navSection";
import { getPreviewScroll, setPreviewScroll } from "../../state/previewScroll";

const withRedux = connect(
  state => ({
    previewScroll: getPreviewScroll(state)
  }),
  dispatch => ({
    setPreviewScroll(value) {
      dispatch(setPreviewScroll({ previewScroll: value }));
    },
    setNavSection(backUrl, title) {
      dispatch(setNavSection({ backUrl, title }));
    }
  })
);

export default withRedux(OverviewLayout);



// WEBPACK FOOTER //
// ./src/components/OverviewLayout/container.js